import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { cleanLengths, sortedLengths } from "@/lib/zips";

const toRows = (lengths) => { const r = sortedLengths(lengths).map(([len, qty]) => ({ len, qty: String(qty) })); return r.length ? r : [{ len: "", qty: "" }]; };

// Quantità della cerniera per lunghezza (cm)
export const LengthsEditor = ({ value, onChange, testid = "lengths" }) => {
  const [rows, setRows] = useState(() => toRows(value));
  const update = (next) => { setRows(next); onChange(cleanLengths(next)); };
  const setCell = (i, k, v) => update(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const total = Object.values(cleanLengths(rows)).reduce((s, q) => s + q, 0);
  return (
    <div className="space-y-1.5" data-testid={testid}>
      {rows.map((r, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input value={r.len} onChange={(e) => setCell(i, "len", e.target.value)} inputMode="decimal" placeholder="Lunghezza" className="h-8 w-24 text-center" data-testid={`${testid}-len-${i}`} />
          <span className="text-xs text-muted-foreground">cm</span>
          <Input value={r.qty} onChange={(e) => setCell(i, "qty", e.target.value)} inputMode="decimal" placeholder="Pezzi" className="h-8 w-24 text-center" data-testid={`${testid}-qty-${i}`} />
          <span className="text-xs text-muted-foreground">pz</span>
          <Button type="button" variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground" onClick={() => update(rows.filter((_, j) => j !== i))} data-testid={`${testid}-remove-${i}`}><Trash2 className="h-3.5 w-3.5" /></Button>
        </div>
      ))}
      <div className="flex items-center justify-between">
        <Button type="button" size="sm" variant="outline" className="h-7" onClick={() => setRows([...rows, { len: "", qty: "" }])} data-testid={`${testid}-add`}><Plus className="mr-1 h-3.5 w-3.5" />Lunghezza</Button>
        <span className="text-xs text-muted-foreground" data-testid={`${testid}-total`}>Totale <b className="text-foreground">{total}</b> pz</span>
      </div>
    </div>
  );
};
